var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9322 6.84018C11.9322 8.73363 10.3973 10.2686 8.50382 10.2686C6.61037 10.2686 5.07541 8.73363 5.07541 6.84018C5.07541 4.94672 6.61037 3.41176 8.50382 3.41176C10.3973 3.41176 11.9322 4.94672 11.9322 6.84018ZM8.50721 11.6356C2.99569 11.6356 1.9375 14.3528 1.9375 15.2244C1.9375 16.0947 2.65551 16.5882 3.32623 16.5882H13.6885C14.3588 16.5882 15.077 16.0951 15.077 15.2244C15.077 14.3529 14.0185 11.6356 8.50727 11.6356H8.50721ZM17.9255 7.47713C18.1412 7.20759 18.0975 6.81428 17.8279 6.59865C17.5584 6.38302 17.1651 6.42672 16.9495 6.69626L14.7878 9.39838L13.9141 8.08783C13.7226 7.80063 13.3345 7.72302 13.0473 7.91449C12.7601 8.10596 12.6825 8.494 12.874 8.78121L14.2218 10.8029L14.6959 11.5141L15.2299 10.8467L17.9255 7.47713Z",
    fill: "url(#paint0_linear_6098_19680)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6098_19680",
    x1: 4.5,
    y1: 3.00002,
    x2: 14.5,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D71E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#415FD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectDone);
export default __webpack_public_path__ + "static/media/connect-done.c4265e7061fb2ccb804fa3b2d1504fb8.svg";
export { ForwardRef as ReactComponent };